// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import isApiError from "@insite/client-framework/Common/isApiError";
import { HasOnError, markSkipOnCompleteIfOnErrorIsSet, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    shareEntity as shareEntityApi,
    shareEntityGenerateFromWebpage,
} from "@insite/client-framework/Services/EmailService";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { SendDataToApi, ShareEntityParameter, chain } from "@insite/client-framework/Store/CommonHandlers/ShareEntity";

type XShareEntityParameter = ShareEntityParameter & HasOnError<string>;

// XNG-Changes: catch API errors to show in the email modal instead of the global error modal
export const xSendDataToApi: typeof SendDataToApi = async props => {
    try {
        const {
            parameter: { generateAttachmentFromWebpage },
            apiParameter,
        } = props;
        const location = getLocation(props.getState());
        props.apiResult = generateAttachmentFromWebpage
            ? await shareEntityGenerateFromWebpage({
                  shareEntityModel: props.parameter.shareEntityModel,
                  urlPathToLoadForAttachmentHtml: location.pathname + location.search,
              })
            : await shareEntityApi(apiParameter);
    } catch (error) {
        const errorMessage = isApiError(error) ? (error.errorJson?.message ?? error.errorMessage) : "";
        (props.parameter as XShareEntityParameter).onError?.(errorMessage);
        return false;
    }
};

replaceInChain(chain, SendDataToApi, xSendDataToApi);
